// Copyright (c) 2016 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateShowPartialDataWarning = (state, action) => action.partialData;

export default (state = getDefaultState().partialData, action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCTS_BY_CUSTOMER_SHOW_PARTIAL_DATA_WARNING]: updateShowPartialDataWarning
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/products-by-customer/reducers/partial-data-warning.js